import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useChatStore = defineStore('chat', () => {
  const showSidebar = ref(true)
  const showSidebarElement = ref(true)

  const toggleSidebar = () => {
    if (showSidebar.value) {
      showSidebar.value = false
    } else {
      showSidebarElement.value = true
      showSidebar.value = true
    }
  }

  return {
    showSidebar,
    showSidebarElement,
    toggleSidebar
  }
})